export const TAB_IDS = {
  AGENDA: "agenda",
  BUILDER: "builder",
  SPEAKERS: "speakers",
  SETTINGS: "settings"
};
